/**
 * @description 國家代號 (enum)
 */
export enum CountriesIdEnum {
  /** 台灣 */
  TW = 'TW'
}
